import { useEffect } from 'react'
import {
  initMetaPixel,
  PRODUCT_EVENT_PARAMS,
  trackMetaEvent,
} from '../utils/metaPixel'

/**
 * Initializes the Meta Pixel, then fires PageView (base code) and ViewContent
 * for the Girls Flag Football Coach System™ product page.
 */
export function useMetaPixel(): void {
  useEffect(() => {
    initMetaPixel()
    trackMetaEvent('ViewContent', PRODUCT_EVENT_PARAMS)
  }, [])
}
